// The one standard for availability times from both endpoints: 24h zero-padded "HH:mm".

const SLOT_CLOCK = /^([01]\d|2[0-3]):([0-5]\d)$/

// Minutes after midnight for a 24h "HH:mm" slot time; anything else is refused.
export const parseSlotClock = (value: unknown): number | null => {
  if (typeof value !== 'string') return null
  const match = value.match(SLOT_CLOCK)
  if (!match) return null
  return Number(match[1]) * 60 + Number(match[2])
}
